import { conversionCopy } from "@/lib/conversionCopy";
import { MessageCircle } from "lucide-react";
import { useLanguage } from "@/lib/useLanguage";

const docKeys = Array.from({ length: 12 }, (_, i) => `docs.${i}`);

const DocumentTypes = () => {
  const { t: originalT, language } = useLanguage();
  const overrides: Record<string, string> = conversionCopy[language].homeText;
  const t = (key: string) => overrides[key] ?? originalT(key);

  return (
    <section className="bg-card py-8 lg:py-12">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-3xl md:text-[40px] font-bold text-primary mb-4">
          {t("docs.heading")}
        </h2>
        <p className="text-muted-foreground text-base mb-12 max-w-2xl mx-auto">
          {t("docs.subtitle")}
        </p>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 mb-10">
          {docKeys.map((key) => (
            <span
              key={key}
              className="bg-background border border-border text-foreground text-sm font-medium px-4 py-2.5 rounded-full"
            >
              {t(key)}
            </span>
          ))}
        </div>
        <a
          href="https://wa.me/66821858187"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-2 text-primary font-semibold hover:underline"
        >
          <MessageCircle className="w-4 h-4" />
          {t("docs.missing")}
        </a>
      </div>
    </section>
  );
};

export default DocumentTypes;
